import styled, { keyframes } from 'styled-components';

export const AppContainer = styled.div`
  display: flex;
  height: 100vh;
  width: 100vw;
  position: relative;
  overflow: hidden;
`;

export const Container = styled.div<{ $sidebarOpen: boolean }>`
  display: flex;
  flex-direction: column;
  height: 100vh;
  flex: 1;
  background-color: ${({ theme }) => theme.colors.background.primary};
  position: relative;
  overflow: hidden;
  transition: ${({ theme }) => theme.transitions.default};

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const Messages = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 70px ${({ theme }) => theme.spacing.xxl} 120px;
  background-color: ${({ theme }) => theme.colors.background.primary};

  .message {
    display: flex;
    margin-bottom: ${({ theme }) => theme.spacing.lg};
    align-items: flex-start;
    gap: ${({ theme }) => theme.spacing.sm};

    &.user {
      flex-direction: row-reverse;
    }

    &.assistant {
      .message-avatar {
        flex-shrink: 0;
        margin-top: ${({ theme }) => theme.spacing.xs};
      }

      .ai-avatar {
        width: 28px;
        height: 28px;
        background-color: ${({ theme }) => theme.colors.primary};
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: ${({ theme }) => theme.colors.background.primary};
      }
    }
  }
`;

export const TypingIndicator = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.xs};
  padding: ${({ theme }) => theme.spacing.lg} ${({ theme }) => theme.spacing.xl};
  background-color: ${({ theme }) => theme.colors.background.primary};
  border: 1px solid ${({ theme }) => theme.colors.border.primary};
  border-radius: ${({ theme }) => theme.borderRadius.large} ${({ theme }) => theme.borderRadius.large} ${({ theme }) => theme.borderRadius.large} ${({ theme }) => theme.borderRadius.small};
`;

const typingAnimation = keyframes`
  0%, 60%, 100% {
    transform: translateY(0);
    opacity: 0.4;
  }
  30% {
    transform: translateY(-10px);
    opacity: 1;
  }
`;

export const TypingDot = styled.div`
  width: 8px;
  height: 8px;
  background-color: ${({ theme }) => theme.colors.border.secondary};
  border-radius: 50%;
  animation: ${typingAnimation} 1.4s infinite ease-in-out;

  &:nth-child(2) {
    animation-delay: 0.2s;
  }

  &:nth-child(3) {
    animation-delay: 0.4s;
  }
`;
